<template>
<div class="chapter">
<div class="inner_page">
<p class="FMH-1"><span class="ePub-BI">Contents</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#cpyntc" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="toc-bot"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">1. You Should Hear the Funeral Choir</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">2. Mistakes Were Made, Now Let’s Move On</a></p>
<p class="toc"><a href="#/xhtml/chapter3#ch3">3. Turtles All the Way Down</a></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">4. The Most Popular Girl at the Debutantes’ Ball</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">5. Next Time, Skip the Wake</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">6. Angel of Death</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">7. Don’t Get Up, I’ll Let Myself Out</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">8. Just Be Glad It Wasn’t a Tuba</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">9. The Good Old Days</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10. Minuet for Two Angels</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11. The Simple Art of Interrogation</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12. Flophouse Lullaby</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13. An Offer You Can’t Refuse</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14. Guardians and Tormentors</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15. Old Friends, New Problems</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">16. Dinner, Dreams, and Death</span></p>
<p class="toc"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">17. Sizing Up the Competition</span></p>
<p class="toc"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">18. This Isn’t Covered in the Enchiridion</span></p>
<p class="toc"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">19. The Final Clue</span></p>
<p class="toc"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">20. A Fool (Almost) Rushes In</span></p>
<p class="toc"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">21. Family Reunion</span></p>
<p class="toc"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">22. Doing the Math</span></p>
<p class="toc-bot"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">23. The End</span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Tor Books by Ian Tregillis</span></p>
<p class="toc"><span href="#/xhtml/abouttheauthor#abt" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#cpy" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?30844936